const digitsOnly = (value: unknown) => String(value || "").replace(/\D/g, "");

export const formatClientPhone = (phone: unknown) => {
  if (!phone) return "";
  if (typeof phone === "string") return phone;
  if (typeof phone !== "object") return "";

  const phoneData = phone as {
    countryCode?: unknown;
    areaCode?: unknown;
    number?: unknown;
  };
  const countryCode = digitsOnly(phoneData.countryCode);
  const areaCode = digitsOnly(phoneData.areaCode);
  const number = digitsOnly(phoneData.number);

  if (!areaCode && countryCode && number.startsWith(countryCode)) {
    return number;
  }

  return `${countryCode}${areaCode}${number}`;
};

const monthAbbreviations = [
  "ENE",
  "FEB",
  "MAR",
  "ABR",
  "MAY",
  "JUN",
  "JUL",
  "AGO",
  "SEP",
  "OCT",
  "NOV",
  "DIC",
];

export const formatLastPaymentDate = (value?: string | null) => {
  if (!value) return "-";

  const date = new Date(value.replace("Z", ""));
  if (Number.isNaN(date.getTime())) return "-";

  const day = String(date.getDate()).padStart(2, "0");
  const month = monthAbbreviations[date.getMonth()];
  const year = String(date.getFullYear()).slice(-2);

  return `${day}/${month}/${year}`;
};

export const formatNumberAmount = (value: number) =>
  new Intl.NumberFormat("es-VE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value ?? 0);

export const formatNullableNumberAmount = (value?: number | null) =>
  value === null || value === undefined ? "--,--" : formatNumberAmount(value);

export const formatUsdAmount = (value: number) => `$ ${formatNumberAmount(value)}`;

export const formatVefAmount = (value: number) =>
  `Bs. ${formatNumberAmount(value)}`;

// Bs per USD as stored: up to 4 decimals, never fewer than 2.
export const formatExchangeRate = (value: number) =>
  new Intl.NumberFormat("es-VE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format(value);

export const formatClientPercentage = (value: number) =>
  `${new Intl.NumberFormat("es-VE", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value ?? 0)}% de clientes`;

export const formatAmountPercentage = (value: number) =>
  `${new Intl.NumberFormat("es-VE", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value ?? 0)}% del monto total`;
